import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  FormGroup,
  Row,
  Col,
  Table,
  Input,
  // Modal,
  // ModalHeader,
  // ModalBody,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AvForm } from "availity-reactstrap-validation";
import TableScrollbar from "react-table-scrollbar";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import moment from "moment";
import "./IGP.scss";

import {
  getIGPRowData,
  getPOItemsList,
} from "../../../store/ingatepass/actions";
import LoadingModel from "../../LoadingModel";

class InGatePass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      isAlertOpen: false,
      selectedItems: {},
    };

    this.toggleTab = this.toggleTab.bind(this);
    this.tog_static = this.tog_static.bind(this);
  }
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 2) {
        this.setState({
          activeTab: tab,
        });
      }
    }
  }

  tog_static(poId) {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
    }));
    this.props.getPOItemsList(poId);
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  componentDidMount() {
    if (this.props.match.params.id > 0) {
      this.props.getIGPRowData(this.props.match.params.id);
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <AvForm className="needs-validation">
              <Row>
                <Col md={12} className="p-1 W-100">
                  <Card className="p-0 ">
                    <CardHeader className="bg-transparent border-bottom ">
                      <div className="float-right ml-2">
                        <Link to={`/igpreportdoc/${this.props.IGPRowData.id}`}>
                          <Button
                            type="submit"
                            color="primary"
                            className="waves-effect waves-light "
                          >
                            Download PDF
                          </Button>
                        </Link>
                      </div>

                      <Link
                        to="/igpdashboard"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                      <h5 className="card-title-18 pt-2 d-inline-block">
                        In Gate Pass ({this.props.IGPRowData.code})
                      </h5>
                    </CardHeader>
                    <CardBody className="p-2 ">
                      <Row>
                        <Col md={6}>
                          <div>
                            <ul className="list-style-two p-0 ml-4  ">
                              <li className="clearfix">
                                <span className="ttl">IGP Date:</span>
                                <span className="dtl">
                                  {moment(
                                    this.props.IGPRowData.createdon
                                  ).format("DD-MM-YYYY")}
                                </span>
                              </li>
                              <li className="clearfix">
                                <span className="ttl">Person Name:</span>
                                <span className="dtl">
                                  {this.props.IGPRowData.personname}
                                </span>
                              </li>
                              <li className="clearfix">
                                <span className="ttl">Vehicle No:</span>
                                <span className="dtl">
                                  {this.props.IGPRowData.vehicleno}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </Col>
                        {/* <Col md={6}>
                          <div>
                            <ul className="list-style-two p-0 ml-4  ">
                              <li className="clearfix">
                                <span className="ttl">Delivery Date:</span>
                                <span className="dtl">
                                  {this.props.IGPRowData.createdon}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </Col> */}
                      </Row>
                      <Row>
                        <Col md={12} className="m-1">
                          <Card className="pt-1">
                            <CardBody className="p-0">
                              <div className="table-responsive m-1">
                                <TableScrollbar height="400px">
                                  <Table className="mb-0 p-1 table-centered">
                                    <thead className="bg-light text-center">
                                      <tr>
                                        <th className="">S.No</th>
                                        <th className="">PO Code</th>
                                        <th className="">PO Bill Image</th>
                                        <th className="">Vendor Code</th>
                                        <th className="">Vendor</th>
                                        <th className="">Items Count</th>
                                        <th className="">Remarks</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.props.IGPPOs.length !== 0 ? (
                                        <>
                                          {this.props.IGPPOs?.map(
                                            (item, key) => (
                                              <>
                                                <tr key={key}>
                                                  <td className="nowrap text-center">
                                                    {key + 1}
                                                  </td>
                                                  <td className="nowrap text-center">
                                                    {item.purchaseorder_code}
                                                  </td>
                                                  <td className="nowrap text-center">
                                                    <div className="product-detail text-center">
                                                      <img
                                                        onClick={() =>
                                                          window.open(
                                                            item?.bill_image
                                                              ?.file == null
                                                              ? DefaultImg
                                                              : item?.bill_image
                                                                  ?.file,
                                                            "PO Bill Image",
                                                            "width=600,height=400"
                                                          )
                                                        }
                                                        src={
                                                          item?.bill_image
                                                            ?.file == null
                                                            ? DefaultImg
                                                            : item?.bill_image
                                                                ?.file
                                                        }
                                                        alt="PO_Bill_Image"
                                                        title="PO Bill Image"
                                                        className="product-img  img-fluid mx-auto tab-img rounded"
                                                        style={{
                                                          height: "100px",
                                                          width: "150px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td className="nowrap text-center">
                                                    {item.vendor.code}
                                                  </td>
                                                  <td className="nowrap text-center">
                                                    {item.vendor.name}
                                                  </td>
                                                  <td className="nowrap text-center">
                                                    {item.items_count}
                                                  </td>
                                                  <td className="nowrap text-center">
                                                    {item.description}
                                                  </td>
                                                </tr>
                                              </>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={9}
                                            className="text-center"
                                          >
                                            <div>
                                              <span className="font-size-18 text-danger">
                                                Data not available
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                </TableScrollbar>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={12} className="m-1">
                          <Card className="pt-1">
                            <CardBody className="p-0">
                              <div className="table-responsive m-1">
                                <TableScrollbar height="400px">
                                  <Table className="mb-0 p-1 table-centered">
                                    <thead className="bg-light text-center">
                                      <tr>
                                        <th className="">S.No</th>
                                        <th className="">IGP ItemCode</th>
                                        <th className="">PO Code</th>
                                        <th className="">PO Item Code</th>
                                        <th className="">Item Image</th>
                                        <th className="">Items Name</th>
                                        <th className="">Received Quantity</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.props.IGPitems.length !== 0 ? (
                                        <>
                                          {this.props.IGPitems?.map(
                                            (item, key) => (
                                              <>
                                                <tr key={key}>
                                                  <td className="nowrap text-center">
                                                    {key + 1}
                                                  </td>
                                                  <td className="nowrap text-center">
                                                    {item.code}
                                                  </td>
                                                  <td className="nowrap text-center">
                                                    {item.purchaseorder_code}
                                                  </td>
                                                  <td className="nowrap text-center">
                                                    {item.poitem_code}
                                                  </td>
                                                  <td className="nowrap text-center">
                                                    <div className="product-detail text-center">
                                                      <img
                                                        src={
                                                          item?.product
                                                            ?.image == null
                                                            ? DefaultImg
                                                            : item?.product
                                                                ?.image
                                                        }
                                                        alt="product-img"
                                                        title="product-img"
                                                        className="product-img  img-fluid mx-auto tab-img rounded"
                                                        style={{
                                                          height: "75px",
                                                          width: "100px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td className="nowrap ">
                                                    <h5 className="font-size-14 ">
                                                      {" "}
                                                      {item.product.name}
                                                    </h5>
                                                    <p className="mb-0">
                                                      Make :{" "}
                                                      <span className="font-weight-medium">
                                                        {item.make}
                                                      </span>
                                                    </p>
                                                    <p className="mb-0">
                                                      Description :{" "}
                                                      <span className="font-weight-medium">
                                                        {item.description}
                                                      </span>
                                                    </p>
                                                    {/* {item.poi_acknowledges
                                                      .length != 0 && (
                                                      <p className="mb-0">
                                                        <b className="text-danger">
                                                          Acknowledge:
                                                        </b>
                                                        <span className="font-weight-medium">
                                                          {
                                                            item
                                                              .poi_acknowledges[0]
                                                              .description
                                                          }
                                                        </span>
                                                      </p>
                                                    )} */}
                                                  </td>
                                                  <td className="nowrap text-center">
                                                    {item.qty} {item.unit.name}
                                                  </td>
                                                </tr>
                                              </>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={9}
                                            className="text-center"
                                          >
                                            <div>
                                              <span className="font-size-18 text-danger">
                                                Data not available
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                </TableScrollbar>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <Card className="p-0 ">
                            <CardHeader className="bg-transparent border-bottom p-1">
                              <i className="mdi mdi-alert-circle-outline ml-2 mr-2 font-size-20"></i>

                              <h5 className="card-title-15 d-inline-block">
                                Other Details
                              </h5>
                            </CardHeader>
                            <CardBody className="p-2 ">
                              <div>
                                <FormGroup className="mb-0">
                                  <Input
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Enter Details"
                                    // maxLength="225"
                                    rows="7"
                                    disabled={true}
                                    value={this.props.IGPRowData.description}
                                  />
                                </FormGroup>{" "}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="p-0 ">
                            <CardHeader className="bg-transparent border-bottom p-1">
                              <Row>
                                <Col md={6}>
                                  <h5 className="card-title-15 d-inline-block">
                                    Vehicle Image
                                  </h5>
                                </Col>
                                <Col md={6}>
                                  <h5 className="card-title-15 d-inline-block">
                                    Person Image
                                  </h5>
                                </Col>
                              </Row>
                            </CardHeader>
                            <CardBody className="p-2 ">
                              <Row>
                                <Col md={6}>
                                  <div className="product-detail text-center">
                                    <img
                                      onClick={() =>
                                        window.open(
                                          this.props.IGPRowData.vehicle_image
                                            ?.file == null
                                            ? DefaultImg
                                            : this.props.IGPRowData
                                                .vehicle_image?.file,
                                          "vehicle Image",
                                          "width=600,height=400"
                                        )
                                      }
                                      src={
                                        this.props.IGPRowData.vehicle_image
                                          ?.file == null
                                          ? DefaultImg
                                          : this.props.IGPRowData.vehicle_image
                                              ?.file
                                      }
                                      alt="vehicle_Image"
                                      title="vehicle Image"
                                      className="product-img  img-fluid mx-auto tab-img rounded"
                                      style={{
                                        height: "180px",
                                        width: "350px",
                                      }}
                                    />
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className="product-detail text-center">
                                    <img
                                      onClick={() =>
                                        window.open(
                                          this.props.IGPRowData.user_image
                                            ?.file == null
                                            ? DefaultImg
                                            : this.props.IGPRowData.user_image
                                                ?.file,
                                          "Person Image",
                                          "width=600,height=400"
                                        )
                                      }
                                      src={
                                        this.props.IGPRowData.user_image
                                          ?.file == null
                                          ? DefaultImg
                                          : this.props.IGPRowData.user_image
                                              ?.file
                                      }
                                      alt="Person_Image"
                                      title="Person Image"
                                      className="product-img  img-fluid mx-auto tab-img rounded"
                                      style={{
                                        height: "180px",
                                        width: "350px",
                                      }}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>
            {/* <Modal
              isOpen={this.state.modal_static}
              toggle={this.tog_static}
              backdrop="static"
              centered
              size="lg"
            >
              <ModalHeader
                toggle={() => this.setState({ modal_static: false })}
              >
                Purchase Order Items
              </ModalHeader>
              <ModalBody className="pt-0">
                <Row className="justify-content-center">
                  <Col md={12}>
                    <div className="table-responsive m-1">
                      <TableScrollbar height="400px">
                        <Table className="mb-0 p-1 table-centered">
                          <thead className="bg-light text-center">
                            <tr>
                              <th className="">S.No</th>
                              <th className="">Code</th>
                              <th className="">Item Image</th>
                              <th className="">Item Name</th>
                              <th>Quantity</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.poItemsList.length !== 0 ? (
                              <>
                                {this.props.poItemsList?.map((item, key) => (
                                  <tr key={key}>
                                    <td className="text-center">{key + 1}</td>
                                    <td className="nowrap text-center">
                                      {item.code}
                                    </td>
                                    <td className="nowrap ">
                                      <img
                                        src={
                                          item.product.image == null
                                            ? DefaultImg
                                            : item.product.image
                                        }
                                        alt="product-img"
                                        title="product-img"
                                        className="avatar-sm"
                                      />
                                    </td>
                                    <td className="nowrap text-center">
                                      {item.product.name}
                                    </td>
                                    <td className="nowrap text-center">
                                      {item.qty} {item.unit.name}
                                    </td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td colSpan={9} className="text-center">
                                  <div>
                                    <span className="font-size-18 text-danger">
                                      Data not available
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </TableScrollbar>
                    </div>
                  </Col>
                </Row>
              </ModalBody>
            </Modal> */}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { IGPRowData, IGPitems, IGPPOs, loading } = state.ingatepass;
  return {
    IGPRowData,
    IGPitems,
    IGPPOs,
    loading,
  };
};

export default connect(mapStatetoProps, {
  getIGPRowData,
  getPOItemsList,
})(InGatePass);
